var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"absolute max-h-full max-w-full object-contain overflow-hidden rounded-lg shadow-2xl select-none bg-gray-800",attrs:{"autoplay":"","controls":"","src":_vm.src},on:{"canplay":_vm.onVideoLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }